import FullPageLoader from "@Components/FullPageLoader";
import loadData from "@Pages/BookForm/data";
import loadable from "@loadable/component";
import NotFound from "@Pages/NotFound";
import ErrorBoundary from "@Components/ErrorBoundary";
import useBookFormPage from "@Pages/BookForm/useBookFormPage";

const ApplicationForm = loadable(() => import("./ApplicationForm"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isLoading, showFullPageLoader } = useBookFormPage(props);

  if (isError) {
    return <NotFound isStatus500 {...props} />;
  }

  if (showFullPageLoader) {
    return <FullPageLoader />;
  }
  return (
    <ErrorBoundary>
      <ApplicationForm {...props} isLoading={isLoading} />
    </ErrorBoundary>
  );
};

export { ApplicationForm as PreFetchApplicationForm };
export { loadData };
